import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import Radio from '../../../../atoms/Radio';
import actionTypes from '../../constants/actionTypes';
import Error from '../../components/error';
import FieldLabel from '../../components/fieldLabel';
var RadioRenderer = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(RadioRenderer, _React$PureComponent);
  var _super = _createSuper(RadioRenderer);
  function RadioRenderer() {
    var _this;
    _classCallCheck(this, RadioRenderer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var _this$props = _this.props,
        id = _this$props.id,
        onAction = _this$props.onAction;
      onAction({
        type: actionTypes.ON_FIELD_CHANGE,
        payload: {
          id: id,
          value: event.target.value
        }
      });
    });
    return _this;
  }
  _createClass(RadioRenderer, [{
    key: "render",
    value: function render() {
      var props = this.props;
      return /*#__PURE__*/React.createElement("div", {
        className: props.fieldClassName
      }, /*#__PURE__*/React.createElement(FieldLabel, props), /*#__PURE__*/React.createElement(Radio, _extends({}, props, {
        onChange: this.handleChange
      })), /*#__PURE__*/React.createElement(Error, props));
    }
  }]);
  return RadioRenderer;
}(React.PureComponent);
export default RadioRenderer;